import React from "react";
import { FormattedMessage } from "react-intl";
import { SectionRow } from "../../styles";
import Container, { ContainerProps } from "./Container";

const MappedDataSources = ({
  toggled,
  updateSourcesLength,
}: ContainerProps) => (
  <SectionRow data-cy="mapped-sources">
    <FormattedMessage id="login.mapped_data_sources" />
    <Container toggled={toggled} updateSourcesLength={updateSourcesLength} />
  </SectionRow>
);

export default MappedDataSources;
